const prefix = 'LIBRARY_DISCOUNT_';

export const LIBRARY_DISCOUNT_SET_OUTLETS = `${prefix}SET_OUTLETS`;

export const LIBRARY_DISCOUNT_OUTLETS_REQUEST = `${prefix}OUTLETS_REQUEST`;

export const LIBRARY_DISCOUNT_ON_CLICK_ROW = `${prefix}ON_CLICK_ROW`;

export const LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS = `${prefix}ON_CHANGE_OUTLET_IDS`;

export const LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT = `${prefix}ON_CLICK_CREATE_DISCOUNT`;

export const LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL = `${prefix}SET_DISCOUNT_DETAIL`;

export const LIBRARY_DISCOUNT_SET_CURRENT_PAGE = `${prefix}SET_CURRENT_PAGE`;

export const LIBRARY_DISCOUNT_SET_TOTAL_PAGE = `${prefix}SET_TOTAL_PAGE`;

export const LIBRARY_DISCOUNT_UNSET_DISCOUNT = `${prefix}UNSET_DISCOUNT`;

export const LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT = `${prefix}SET_CREATE_DISCOUNT`;

export const LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD = `${prefix}CLEAR_AMOUNT_FIELD`;

export const LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE = `${prefix}SUBMIT_FORM_CREATE`;

export const LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET = `${prefix}SUBMIT_FORM_CREATE_ALL_OUTLET`;

export const LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE = `${prefix}SUBMIT_FORM_UPDATE`;

export const LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT = `${prefix}ASK_DELETE_DISCOUNT`;

export const LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL = `${prefix}SHOW_DELETE_DISCOUNT_MODAL`;

export const LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL = `${prefix}HIDE_DELETE_DISCOUNT_MODAL`;

export const LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT = `${prefix}SET_DELETED_DISCOUNT`;

export const LIBRARY_DISCOUNT_DELETE_DISCOUNT = `${prefix}DELETE_DISCOUNT`;

export const LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT = `${prefix}CANCEL_DELETE_DISCOUNT`;

export const LIBRARY_DISCOUNT_ON_CLICK_CANCEL = `${prefix}ON_CLICK_CANCEL`;

export const LIBRARY_DISCOUNT_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL = `${prefix}ASSIGN_OUTLET_MODAL`;

export const LIBRARY_DISCOUNT_IS_SUBMITTING_FORM = `${prefix}IS_SUBMITTING_FORM`;

export const LIBRARY_DISCOUNT_ON_CLICK_ASSIGN_OUTLET = `${prefix}ON_CLICK_ASSIGN_OUTLET`;

export const LIBRARY_DISCOUNT_SHOW_ASSIGN_OUTLET_MODAL = `${prefix}SHOW_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_DISCOUNT_HIDE_ASSIGN_OUTLET_MODAL = `${prefix}HIDE_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_DISCOUNT_SET_SELECTED_OUTLETS = `${prefix}_SET_SELECTED_OUTLETS`;

export const LIBRARY_DISCOUNT_SET_PARTIAL_OUTLETS = `${prefix}_SET_PARTIAL_OUTLETS`;

export const LIBRARY_DISCOUNT_SEARCH_OUTLET = `${prefix}_SEARCH_OUTLET`;

export const LIBRARY_DISCOUNT_SELECT_ALL_OUTLETS = `${prefix}OUTLET_SELECT_ALL_OUTLETS`;

export const LIBRARY_DISCOUNT_UNSELECT_ALL_OUTLETS = `${prefix}OUTLET_UNSELECT_ALL_OUTLETS`;

export const LIBRARY_DISCOUNT_ON_CLICK_ASSIGN_DISCOUNT_ASSIGN_OUTLET_MODAL = `${prefix}OUTLET_ON_CLICK_ASSIGN_DISCOUNT_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_DISCOUNT_OUTLET_SUBMIT_FORM_UPDATE = `${prefix}OUTLET_SUBMIT_FORM_UPDATE`;

export const LIBRARY_DISCOUNT_OUTLET_DELETE_DISCOUNT = `${prefix}OUTLET_DELETE_DISCOUNT`;

export const LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_OUTLET_NOT_ASSIGNED = `${prefix}OUTLET_SHOW_ERROR_OUTLET_NOT_ASSIGNED`;

export const LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_OUTLET_NOT_ASSIGNED = `${prefix}OUTLET_HIDE_ERROR_OUTLET_NOT_ASSIGNED`;

export const LIBRARY_DISCOUNT_OUTLET_SHOW_BUTTON_VIEW_MORE_OUTLETS = `${prefix}OUTLET_SHOW_BUTTON_VIEW_MORE_OUTLETS`;

export const LIBRARY_DISCOUNT_OUTLET_HIDE_BUTTON_VIEW_MORE_OUTLETS = `${prefix}OUTLET_HIDE_BUTTON_VIEW_MORE_OUTLETS`;

export const LIBRARY_DISCOUNT_OUTLET_ON_CLICK_VIEW_MORE_OUTLETS = `${prefix}OUTLET_ON_CLICK_VIEW_MORE_OUTLETS`;

export const LIBRARY_DISCOUNT_OUTLET_SHOW_ERROR_DUPLICATE_DISCOUNT_NAME = `${prefix}OUTLET_SHOW_ERROR_DUPLICATE_DISCOUNT_NAME`;

export const LIBRARY_DISCOUNT_OUTLET_HIDE_ERROR_DUPLICATE_DISCOUNT_NAME = `${prefix}OUTLET_HIDE_ERROR_DUPLICATE_DISCOUNT_NAME`;
